import { render } from "./BrandPortfolioChildrenRow.vue?vue&type=template&id=2359b415"
import script from "./BrandPortfolioChildrenRow.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioChildrenRow.vue?vue&type=script&lang=js"

import "./BrandPortfolioChildrenRow.vue?vue&type=style&index=0&id=2359b415&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__